export const GITA_HOME = '/';

export function gitaChapterPath(chapter) {
  return `/${chapter}`;
}

export function gitaVersePath(chapter, verse) {
  return `/${chapter}/${verse}`;
}
